<bfd-loading [fullScreen]="loading" [show]="loading"></bfd-loading>
<bfd-generic-modal
  *ngIf="showError"
  [title]="'Desculpe, mas tivemos um erro!'"
  [message]="
    'Tivemos um erro inesperados e não conseguimos acessa a página solicitada. Tente novamente, e caso o erro continue volte mais tarde.'
  "
  (tryEventEmmitter)="tryRequest($event)"
></bfd-generic-modal>
<div>
  <bfd-popover
    [content]="balanceSingle"
    [visible]="popoverService.shouldLoad"
    [view]="typeView"
  ></bfd-popover>
  <bfd-divider [padding]="'small'"></bfd-divider>
  <bfd-card-value
    *ngIf="accountBalance?.listBalance.length > 0"
    [title]="accountBalance.titleBalance"
    [body]="accountBalance.listBalance"
    [button]="accountBalance.button"
    (clikedEmitter)="getInfPopover($event, 'blocked-balance')"
  ></bfd-card-value>
  <bfd-divider [padding]="'small'"></bfd-divider>
  <bfd-card-value
    *ngIf="fibraFacilBalance?.listBalance.length > 0"
    [title]="fibraFacilBalance.titleBalance"
    [body]="fibraFacilBalance.listBalance"
    [button]="'Entenda seu limite'"
    (clikedEmitter)="getInfPopover($event, 'fibra-facil')"
  ></bfd-card-value>
  <bfd-divider [padding]="'small'"></bfd-divider>
  <bfd-card-value
    *ngIf="movements?.listBalance.length > 0"
    [title]="movements.titleBalance"
    [body]="movements.listBalance"
  ></bfd-card-value>
  <bfd-divider
    *ngIf="
      accountBalance?.listBalance.length > 0 ||
      fibraFacilBalance?.listBalance.length > 0 ||
      movements?.listBalance.length > 0
    "
    [type]="'divider'"
    [padding]="'ultra'"
  ></bfd-divider>
</div>
<app-period-filter
  [title]="'Detalhe das movimentações'"
  [scheduling]="false"
  (rangeChange)="handleRange($event)"
></app-period-filter>

<div class="table-content">
  <bfd-tab-menu
    [menus]="menu"
    [prefix]="mainPrefix"
    (menusEmitter)="changePage($event)"
  ></bfd-tab-menu>
  <bfd-container-display-message
    *ngIf="balanceObj?.length === 0"
    [content]="contentEmptyData"
  ></bfd-container-display-message>
  <bfd-transaction-table
    *ngIf="balanceObj?.length > 0"
    [tableOrigin]="'general-view'"
    [data]="balanceObj"
    (dataEmitter)="getInfBalance($event, 'detail-statement')"
  ></bfd-transaction-table>
  <bfd-loading [fullScreen]="loading" [show]="loadingScroll && balanceObj.length > 0"></bfd-loading>
  <div #anchor class="anchor"></div>
</div>
